import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=19153ebf"
import script from "./Free.vue?vue&type=script&setup=true&lang=ts"
export * from "./Free.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports